import {
  AppointmentControllerApi,
  SendPaymentLinkPaymentCategoryEnum,
} from "../services";
import { getConfigObject, useMutationWithLoading } from "../utils/utils";

interface Params {
  appointmentId: string;
  amount: number;
  currency?: string;
  resend?: boolean;
  xTENANTID?: string;
  paymentCategory?: SendPaymentLinkPaymentCategoryEnum;
}

/**
 * @author  [Rajkumar Rathod]
 */
export const usePaymentLinkUrl = () =>
  useMutationWithLoading(async (params: Params) =>
    new AppointmentControllerApi(getConfigObject())
      .sendPaymentLink(
        params.appointmentId,
        params.amount,
        params.currency,
        params?.paymentCategory, // paymentCategory
        params.resend ?? false,
        params.xTENANTID
      )
      .then((res) => res?.data)
  );
